module.exports = __webpack_public_path__ + "img/btn-games.c9d66566.png";